module.exports = __webpack_public_path__ + "static/media/stop.133db7a8.svg";